/**
 * @author     Shivam Shrivastava
 * @date        Nov, 2024
 * @copyright   www.ibirdsservices.com
 */

import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import SparkApi from "../api/SparkApi";
import { Oval } from 'react-loader-spinner';
import "../index.css"

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({ email: "" });
    let [loader , setLoader ] = useState(false);

    const [getotp, getOtp] = React.useState();
    const [otp, setOtp] = React.useState();
    const [timeRemaining, setTimeRemaining] = useState(60);
    const [flage, setFlage] = React.useState(false);

    // const emailUsername = credentials.email.split('@')[0];
    // const maskedUsername = emailUsername.length > 2
    //     ? `${emailUsername[0]}${'*'.repeat(emailUsername.length - 2)}${emailUsername.slice(-1)}`
    //     : emailUsername;

    const email = credentials.email;
    const [username, domain] = email.split("@");
    console.log('username->',username);
    console.log('domain->',domain);
    
    const maskedUsername =
      username.length > 2
        ? `${username[0]}${"*".repeat(username.length - 2)}${username.slice(-1)}`
        : username;
    
    const maskedEmail = `${maskedUsername}@${domain}`;
    const setTimeOut = async (e) => {
        const timerInterval = setInterval(() => {
            setTimeRemaining(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(timerInterval);
                    setOtp()
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
        return () => clearInterval(timerInterval);
    }

    const customToastStyle = {
        width: "400px",  // Increase Width
        color: "red",    // Red Text Color
      };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         if (!credentials.email) {
    //             toast.error("Please fill email");
    //             return;
    //         }
    //         console.log('handleSubmit == ', credentials);
    //         let result;
    //         if (!flage || timeRemaining === 0) {
    //             result = await SparkApi.ForgetPasswordApi(credentials);
    //             console.log("result-->", result);
    //             if (result.success) {
    //                 setTimeRemaining(60)
    //                 setTimeOut();
    //                 console.log(result)
    //                 toast.success(result.message);
    //                 if (result.otp) {
    //                     setFlage(true)
    //                     getOtp(result.otp)
    //                 }
    //                 else {
    //                     setFlage(false)
    //                 }
    //             }
    //             else {
    //                 toast.error(result.message ,  {style : customToastStyle});
    //             }
    //         }
    //         else {
    //             // console.log("result otp == ", getotp)
    //             // console.log("check otp == ", otp)

    //             if (!otp) {
    //                 toast.error("Enter OTP First");
    //                 return;
    //             }
    //             if (getotp == otp) {

    //                 navigate(`/reset-password/${credentials.email}`);
    //             }
    //             else {
    //                 toast.error("Incorrect OTP");
    //             }
    //         }
    //     } catch (error) {
    //         console.log('server-error--->>>' , error);
    //     }
    // };

    const handleSubmit = async (e) => {
        try{
          e.preventDefault();
          if (!credentials.email) {
            toast.error("Please enter email!");
            return;
          }
          let result;
          let otpResult;
          if (!flage || timeRemaining === 0) {
            setLoader(true)
            result = await SparkApi.ForgetPasswordApi(credentials);
            if (result.success) {
              setTimeRemaining(60);
              setTimeOut();
              toast.success(result.message);
              setLoader(false)
              setFlage(true);
            } else {
              setLoader(false)
              toast.error(result.message);
            }
          } else {
            if (!otp) {
              toast.error("Enter OTP First");
              return;
            }
              try{
                let schoolCode = credentials.school_code ? credentials.school_code : "public"
                console.log("schoolCode == ",schoolCode)
                otpResult = await SparkApi.CheckOtp(credentials.email, otp);
                if (otpResult.success) {
                setLoader(false)
    
                  navigate(`/reset-password/${credentials.email}`, {
                    state: { school_code: credentials.school_code },
                  });
                } else {
                  setLoader(false)
                  toast.error("Incorrect OTP");
                }
              }catch(e){
                toast.error(e.response.data.message);
                setLoader(false)
              }
          }
        }catch(e){
          setLoader(false)
    
          toast.error(e.response.data.message);
        }
      };

    const handleChange = (e) => {
        if (e.target.name === 'otp') {
            // console.log('otp == ', e.target.value)
            // const otpValue = e.target.value.slice(0, 6);
            const otpValue = e.target.value.replace(/\D/g, "").slice(0, 6);
            setOtp(otpValue);
        }
        else {
            setCredentials({ ...credentials, [e.target.name]: e.target.value });
        }
    };

    return (
        <Container className={loader ? 'disabled-screen' : ""}>
        {loader &&
          <div className="d-flex justify-content-center align-items-center loader_forget_passwords">
            <Oval
              visible={true}
              height="100"
              width="140"
              color="#275b6b"
              ariaLabel="oval-loading"
              wrapperClass=""
            />
          </div>
         }
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <div className="sm-w-40 justify-content-center">
                <div>
                    <div className="p-4 sm-p-4 shadow-sm bg-white rounded">
                        <Form className="mt-2" onSubmit={handleSubmit}>
                            <div className="">
                                <h3 className="text-center ">
                                    <img src="/srmlogo.jpg" style={{ width: "120px" }} className="mb-2 img-fluid" alt="" />
                                    <div>Convert, before it fades away</div>
                                </h3>
                                {flage &&
                                    <div>
                                        <p className="fs-5 mt-4 text-bg-danger">Enter your verification code</p>
                                        <p className="fs-5 mt-4">Please enter one-time password to verify your account.</p>
                                        <p className="fs-5 "> A code has been sent to {`${maskedEmail}`}</p>
                                    </div>
                                }
                            </div>

                            <Form.Group className="mb-3 mt-2" controlId="formBasicusername">
                                {!flage && <Row className="mt-3">
                                    <Col lg={12} className="mt-3">
                                        <Form.Label>Enter Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            onChange={handleChange}
                                            placeholder="Enter Your Official Email"
                                            value={credentials.email}
                                        />
                                    </Col>
                                </Row>
                                }
                                {flage &&
                                    <Row className="mt-3">
                                        <Col lg={12}>
                                            <Form.Label>OTP</Form.Label>
                                            <Form.Control
                                                type="phone"
                                                name="otp"
                                                onChange={handleChange}
                                                placeholder="Enter OTP"
                                                value={otp}
                                            />
                                            <div className="mt-2">
                                                {timeRemaining !== 0 && <p>Time remaining: {timeRemaining} seconds</p>}
                                                {timeRemaining === 0 && <p>OTP expired. Please request a new one.
                                                    <span className="mx-2" style={{ color: 'blue', cursor: 'pointer', fontWeight: "bold" }} onClick={handleSubmit}>Resend</span>
                                                </p>}
                                            </div>
                                        </Col>
                                    </Row>
                                }
                                <Row className="mt-3">
                                    <Col lg={12} >
                                        <Button
                                            className="btn btn-lg w-100 submit"
                                            variant="primary"
                                            type="submit"
                                            disabled={flage && timeRemaining === 0}
                                        >
                                            {flage ? "Verify" : "Submit"}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <center className="mt-3">
                                <strong><Link to="/login" style={{ textDecoration: 'none' }}>Back to Login</Link></strong>
                            </center>
                        </Form>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1500} theme="light" />
        </Container>
        </Container>
    );
};

export default ForgetPassword;